export enum StoreStatus {
  BUSY = 'busy',
  IDLE = 'idle',
  ERROR = 'error',
}

export enum OrderStatus {
  CREATED = 'CREATED',
  DISPATCHED = 'DISPATCHED',
}

export enum OrderCondition {
  Viable = 'Viable',
  'Non-viable' = 'Non-viable',
}

export interface GraphQlErrorLocation {
  line: number;
  column: number;
  sourceName: string | null;
}

export interface GraphQlError {
  path: string[];
  data: string | null;
  errorType: string;
  errorInfo: string | null;
  locations: GraphQlErrorLocation[];
  message: string;
}

export interface Participant {
  participantId: string;
  participantRef: string;
  firstName: string;
  surname: string;
  dob: string;
  sexAtBirth: string;
  nhsNumber: string;
  participantStatus: string;
  sampleBarcode?: string | null;
}

export interface SampleKit {
  sampleBarcode: string | null;
  linkDate: string | null;
}

export interface SampleLink {
  sampleBarcode: string;
  participantId: string;
  sampleLinkDate: string;
}

export type GetParticipantResponse = {
  data?: { getParticipantDetails: Participant };
  errors?: GraphQlError[];
};

export type LinkParticipantSampleResponse = {
  data?: { linkParticipantSample: SampleLink };
  errors?: GraphQlError[];
};

export interface LinkParticipantSampleRequest {
  participantId: string;
  sampleBarcode: string;
}
